define('OutSystems/ReactWidgets/Form',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Form = void 0;
    var Form = (function (_super) {
        tslib_1.__extends(Form, _super);
        function Form() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(Form.prototype, "isValidationAggregator", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        Form.prototype.render = function () {
            var _a, _b;
            var formAttributes = {
                "data-form": "",
                action: (_b = (_a = this.props.extendedProperties) === null || _a === void 0 ? void 0 : _a.action) !== null && _b !== void 0 ? _b : "",
                noValidate: true,
                className: this.props.style,
                onSubmit: function (e) { return e.preventDefault(); },
            };
            this.fillWithBuiltinProperties(formAttributes);
            return React.createElement("form", tslib_1.__assign({}, formAttributes), this.props.children);
        };
        Form = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Form);
        return Form;
    }(Widget_1.ValidationWidget));
    exports.Form = Form;
});
//# sourceMappingURL=Form.js.map;
